module.exports = __webpack_public_path__ + "static/img/flow-chart.2859804.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/flow-chart.png
// module id = 1664
// module chunks = 2